import { PackageAvailability } from '@bhtp-client-api/purchase';
export class PackageAvailabilityHelper {
    public static canSellPackage(pkg: PackageAvailability): boolean {
        let canSell: boolean = true;

        if (!pkg || !pkg.canSell || !pkg.availablePlatform) {
            canSell = false;
        }
        else {
            let availablePlatform: string[] = pkg.availablePlatform.toLowerCase().split(';');
            canSell = availablePlatform.some(ap => ap === 'agent');
        }

        return canSell;
    }
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/typescript/shared/helpers/package-availability.helper.ts